import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { VOMI_COLORS } from './colors';

export const VomiPreset = definePreset(Aura, {
  semantic: {
    primary: { ...VOMI_COLORS.primary },
    colorScheme: {
      light: {
        primary: {
          color: VOMI_COLORS.primary[500],
          contrastColor: '#FFFFFF',
          hoverColor: VOMI_COLORS.primary[600],
          activeColor: VOMI_COLORS.primary[700],
        },
        surface: {
          0: '#FFFFFF',
          50: '#F8FAF9',
          100: VOMI_COLORS.primary[50],
          200: '#F0F4F1',
          300: VOMI_COLORS.gray[200],
          400: VOMI_COLORS.primary[200],
          500: '#B8B5A7',
          600: VOMI_COLORS.gray[500],
          700: VOMI_COLORS.text.DEFAULT,
          800: VOMI_COLORS.text.DEFAULT,
          900: VOMI_COLORS.text.DEFAULT,
          950: VOMI_COLORS.text.DEFAULT,
        },
      },
    },
  },
});
